import { Map } from 'immutable';
import { connect } from '../../../react-redux';
import PaginatedCollection from './presenter';
import { merge, set } from '../../../actions/ui';
export function mapStateToProps(state, props) {
  var pageData = state.getIn(['ui', props.stateKey], Map());
  var totalPages = pageData.get('total', 0);
  var currentPage = pageData.get('current', 1);
  var contents = pageData.get('contents', Map());
  return {
    totalPages: totalPages,
    currentPage: currentPage,
    contents: contents
  };
}
export default connect(mapStateToProps, {
  merge: merge,
  set: set
})(PaginatedCollection);